import React, { FC, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import { ProductOptionGroups } from "./ProductOptionGroups.tsx";
import { Stack } from "@mui/material";
import { ProductAttributes } from "../../../../Domains/Products/api/productJsonApi.ts";
import _ from "lodash";
import { RenderOption } from "../../views/OptionGroups/Tabs/AutocompleteProductRenderOption.tsx";
import { AutocompleteProduct } from "@jamezz/react-components";
import { OptionGroupData, ProductData, ProductOptionGroupDataContext } from "./ProductAndOptionGroupContext.tsx";
import { GET_PRODUCTS } from "../../../../Domains/Products/api/productGraphQLApi.ts";

export type DiscountedProduct = {
  id: number;
  maxCount: number;
  optionGroups?: DiscountedOptionGroup[];
};

export type DiscountedOptionGroup = {
  id: number;
  maxCount: number;
  allOptionsCount: boolean;
  options?: DiscountedProduct[];
};

type DiscountedProductsTableProps = {
  discountedProducts: DiscountedProduct[];
  replace: (products: DiscountedProduct[]) => void;
  onChange: (products: DiscountedProduct[]) => void;
  salesAreaId: number;
};

export const DiscountedProductsTable: FC<DiscountedProductsTableProps> = ({
  discountedProducts,
  replace,
  onChange,
  salesAreaId,
}) => {
  const [allProducts, setAllProducts] = useState<ProductData>({});
  const [allOptionGroups, setAllOptionGroups] = useState<OptionGroupData>({});

  const productIds = useMemo(() => {
    return discountedProducts.map((value) => value.id);
  }, [discountedProducts]);

  return (
    <Stack direction={"column"} gap={2} width={1} sx={{ my: 2 }}>
      <AutocompleteProduct<true, ProductAttributes, true>
        multiple={true}
        menuSalesareaId={salesAreaId}
        fetchQuery={GET_PRODUCTS}
        inputFieldProps={{ sx: { width: 1 } }}
        defaultFilters={{
          vestiging_id: { field: "vestiging_id", operator: "=", value: salesAreaId },
          is_option: { field: "is_option", value: false },
        }}
        onFetched={(fetchedData) => {
          setAllProducts(_.merge({}, allProducts, _.keyBy(fetchedData, "id")));
        }}
        onChange={(option) => {
          replace(
            _.map(option, (option) => ({
              id: option.id,
              maxCount: 0,
              optionGroups: [],
            }))
          );
        }}
        value={productIds}
        renderOption={(props, option) => <RenderOption option={option} />}
      />
      <ProductOptionGroupDataContext.Provider
        value={{
          productData: allProducts,
          optionGroupData: allOptionGroups,
          setProductData: setAllProducts,
          setOptionGroupData: setAllOptionGroups,
        }}
      >
        <Box sx={{ width: "100%" }}>
          {discountedProducts.map((discountedProduct) => {
            return (
              <ProductOptionGroups
                key={discountedProduct.id}
                expanded={false}
                salesAreaId={salesAreaId}
                discountedProduct={discountedProduct}
                onChange={(changedProduct) => {
                  onChange(
                    discountedProducts.map((product) => {
                      if (product.id === changedProduct.id) {
                        return changedProduct;
                      }

                      return product;
                    })
                  );
                }}
              />
            );
          })}
        </Box>
      </ProductOptionGroupDataContext.Provider>
    </Stack>
  );
};
